/**
 * 回傳縮寫（大寫的第一個字母）
 * @param name: String
 * @returns String
 */

const provideAbbrev = (name: string): string => {
  return name.substring(0, 1).toUpperCase();
};

export default provideAbbrev;
